import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PostList from './PostList';
import PostDetail from './PostDetail';
import NewPostForm from './NewPostForm';
import { useNavigate } from 'react-router-dom';
import JobApplicationManager from './JobApplicationManager';

function ForumPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasSubscribed, setHasSubscribed] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showNewPostForm, setShowNewPostForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [notification, setNotification] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, { withCredentials: true });
        if (res.data.isAuthenticated && res.data.user) {
          setIsAuthenticated(true);
          setUser(res.data.user);
          setHasSubscribed(!!res.data.user.hasSubscribed);
          setSessionId(res.data.user.sessionId || '');
        } else {
          setErrorMessage('Please log in (and subscribe) to access the forum.');
        }
      } catch (err) {
        setErrorMessage('Failed to check session.');
      } finally {
        setAuthChecked(true);
      }
    };
    checkSession();
  }, []);

  useEffect(() => {
    if (authChecked && isAuthenticated && (hasSubscribed || user?.accountType === 'Admin')) {
      fetchPosts();
    }
  }, [authChecked, isAuthenticated, hasSubscribed, user]);

  const fetchPosts = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, { withCredentials: true });
      setPosts(res.data.posts || []);
    } catch (err) {
      setErrorMessage('Could not load forum posts.');
    }
  };

  const handleCreatePost = async (formData) => {
    try {
      formData.append('subscriberId', user.id);
      const res = await axios.post(`${process.env.REACT_APP_API}/new/forum/post`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      setPosts([res.data.post, ...posts]);
      setShowNewPostForm(false);
      setNotification('Post created successfully!');
      setTimeout(() => setNotification(''), 3000);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Failed to create post.');
    }
  };

  const handleSelectPost = async (postId) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, { withCredentials: true });
      setSelectedPost(res.data.post);
    } catch {
      setErrorMessage('Could not load selected post.');
    }
  };

  const handleLikePost = async (postId) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/like/forum/post/${postId}`, {
        subscriberId: user.id
      }, { withCredentials: true });
      updatePostLikes(postId, res.data.updatedPost.likes);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Failed to like post.');
    }
  };

  const handleDislikePost = async (postId) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/dislike/forum/post/${postId}`, {
        subscriberId: user.id
      }, { withCredentials: true });
      updatePostLikes(postId, res.data.updatedPost.likes);
    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
    }
  };

  const updatePostLikes = (postId, likes) => {
    setPosts(prev => prev.map(p => p._id === postId ? { ...p, likes } : p));
    if (selectedPost?._id === postId) {
      setSelectedPost(prev => ({ ...prev, likes }));
    }
  };

  const handleBackToList = () => {
    setSelectedPost(null);
    setShowNewPostForm(false);
  };

  if (!authChecked) return <p>Verifying session...</p>;
  if (!isAuthenticated) return <p>Please log in to access the forum.</p>;
  if (!hasSubscribed && user?.accountType !== 'Admin') return <p>You must subscribe to access the forum.</p>;

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Government Accounting Discussion Forum</h2>

      <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <button onClick={() => navigate('/admin-dashboard')}>🚀 Admin Dashboard</button>
        <button onClick={() => navigate('/rpa')}>📊 RPA Dashboard</button>
        <button onClick={() => navigate('/cmmc')}>🛡️ CMMC Tracker</button>
        <button onClick={() => navigate('/hud')}>🏠 HUD Analytics</button>
      </div>

      {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
      {notification && <div style={{ color: 'green' }}>{notification}</div>}

      {!selectedPost && !showNewPostForm && (
        <>
          <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
          <JobApplicationManager />
        </>
      )}

      {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
      {selectedPost ? (
        <PostDetail
          post={selectedPost}
          onLike={handleLikePost}
          onDislike={handleDislikePost}
          onBack={handleBackToList}
        />
      ) : (
        <PostList posts={posts} onSelectPost={handleSelectPost} />
      )}
    </div>
  );
}

export default ForumPage;





// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';
// import { useNavigate } from 'react-router-dom';
// import JobApplicationManager from './JobApplicationManager';

// function ForumPage() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [notification, setNotification] = useState('');

//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, { withCredentials: true });
//         if (res.data.isAuthenticated && res.data.user) {
//           setIsAuthenticated(true);
//           setUser(res.data.user);
//           setHasSubscribed(!!res.data.user.hasSubscribed);
//           setSessionId(res.data.user.sessionId || '');
//         } else {
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (err) {
//         setErrorMessage('Failed to check session.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };
//     checkSession();
//   }, []);

//   useEffect(() => {
//     if (authChecked && isAuthenticated && (hasSubscribed || user?.accountType === 'Admin')) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed, user]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, { withCredentials: true });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       setErrorMessage('Could not load forum posts.');
//     }
//   };

//   const handleCreatePost = async (formData) => {
//     try {
//       formData.append('subscriberId', user.id);
//       const res = await axios.post(`${process.env.REACT_APP_API}/new/forum/post`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         withCredentials: true,
//       });
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//       setNotification('Post created successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to create post.');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, { withCredentials: true });
//       setSelectedPost(res.data.post);
//     } catch {
//       setErrorMessage('Could not load selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/like/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleDislikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/dislike/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
//     }
//   };

//   const updatePostLikes = (postId, likes) => {
//     setPosts(prev => prev.map(p => p._id === postId ? { ...p, likes } : p));
//     if (selectedPost?._id === postId) {
//       setSelectedPost(prev => ({ ...prev, likes }));
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) return <p>Verifying session...</p>;
//   if (!isAuthenticated) return <p>Please log in to access the forum.</p>;
//   if (!hasSubscribed && user?.accountType !== 'Admin') return <p>You must subscribe to access the forum.</p>;

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>

//       <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
//         <button onClick={() => navigate('/admin-dashboard')}>🚀 Admin Dashboard</button>
//         <button onClick={() => navigate('/rpa')}>📊 RPA Dashboard</button>
//         <button onClick={() => navigate('/cmmc')}>🛡️ CMMC Tracker</button>
//       </div>

//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {notification && <div style={{ color: 'green' }}>{notification}</div>}

//       {!selectedPost && !showNewPostForm && (
//         <>
//           <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//           <JobApplicationManager />
//         </>
//       )}

//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail
//           post={selectedPost}
//           onLike={handleLikePost}
//           onDislike={handleDislikePost}
//           onBack={handleBackToList}
//         />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;








// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';
// import { useNavigate } from 'react-router-dom';
// import JobApplicationManager from './JobApplicationManager';

// function ForumPage() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [notification, setNotification] = useState('');

//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, { withCredentials: true });
//         if (res.data.isAuthenticated && res.data.user) {
//           setIsAuthenticated(true);
//           setUser(res.data.user);
//           setHasSubscribed(!!res.data.user.hasSubscribed);
//           setSessionId(res.data.user.sessionId || '');
//         } else {
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (err) {
//         setErrorMessage('Failed to check session.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };
//     checkSession();
//   }, []);

//   useEffect(() => {
//     if (authChecked && isAuthenticated && (hasSubscribed || user?.accountType === 'Admin')) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed, user]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, { withCredentials: true });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       setErrorMessage('Could not load forum posts.');
//     }
//   };

//   const handleCreatePost = async (formData) => {
//     try {
//       formData.append('subscriberId', user.id);
//       const res = await axios.post(`${process.env.REACT_APP_API}/new/forum/post`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         withCredentials: true,
//       });
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//       setNotification('Post created successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to create post.');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, { withCredentials: true });
//       setSelectedPost(res.data.post);
//     } catch {
//       setErrorMessage('Could not load selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/like/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleDislikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/dislike/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
//     }
//   };

//   const updatePostLikes = (postId, likes) => {
//     setPosts(prev => prev.map(p => p._id === postId ? { ...p, likes } : p));
//     if (selectedPost?._id === postId) {
//       setSelectedPost(prev => ({ ...prev, likes }));
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) return <p>Verifying session...</p>;
//   if (!isAuthenticated) return <p>Please log in to access the forum.</p>;
//   if (!hasSubscribed && user?.accountType !== 'Admin') return <p>You must subscribe to access the forum.</p>;

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>

//       <div style={{ marginBottom: '1rem' }}>
//         <button onClick={() => navigate('/admin-dashboard')}>🚀 Admin Dashboard</button>
//       </div>

//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {notification && <div style={{ color: 'green' }}>{notification}</div>}

//       {!selectedPost && !showNewPostForm && (
//         <>
//           <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//           <JobApplicationManager />
//         </>
//       )}

//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail
//           post={selectedPost}
//           onLike={handleLikePost}
//           onDislike={handleDislikePost}
//           onBack={handleBackToList}
//         />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;










// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// function ForumPage() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [notification, setNotification] = useState('');

//   const [adminPin, setAdminPin] = useState('');
//   const [adminAccessGranted, setAdminAccessGranted] = useState(false);

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, { withCredentials: true });
//         if (res.data.isAuthenticated && res.data.user) {
//           setIsAuthenticated(true);
//           setUser(res.data.user);
//           setHasSubscribed(!!res.data.user.hasSubscribed);
//           setSessionId(res.data.user.sessionId || '');
//         } else {
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (err) {
//         setErrorMessage('Failed to check session.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };
//     checkSession();
//   }, []);

//   useEffect(() => {
//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, { withCredentials: true });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       setErrorMessage('Could not load forum posts.');
//     }
//   };

//   const handleCreatePost = async (formData) => {
//     try {
//       formData.append('subscriberId', user.id);
//       const res = await axios.post(`${process.env.REACT_APP_API}/new/forum/post`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         withCredentials: true,
//       });
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//       setNotification('Post created successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to create post.');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, { withCredentials: true });
//       setSelectedPost(res.data.post);
//     } catch {
//       setErrorMessage('Could not load selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/like/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleDislikePost = async (postId) => {
//     try {
//       const res = await axios.post(`${process.env.REACT_APP_API}/dislike/forum/post/${postId}`, {
//         subscriberId: user.id
//       }, { withCredentials: true });
//       updatePostLikes(postId, res.data.updatedPost.likes);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
//     }
//   };

//   const updatePostLikes = (postId, likes) => {
//     setPosts(prev => prev.map(p => p._id === postId ? { ...p, likes } : p));
//     if (selectedPost?._id === postId) {
//       setSelectedPost(prev => ({ ...prev, likes }));
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   const handleAdminAccess = () => {
//     if (adminPin === '1212') {
//       setAdminAccessGranted(true);
//       window.location.href = '/admin-dashboard';
//     } else {
//       alert('Invalid PIN. Access denied.');
//     }
//   };

//   if (!authChecked) return <p>Verifying session...</p>;
//   if (!isAuthenticated) return <p>Please log in to access the forum.</p>;
//   if (!hasSubscribed) return <p>You must subscribe to access the forum.</p>;

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>

//       <div style={{ marginBottom: '1rem' }}>
//         <input
//           type="password"
//           placeholder="Enter Admin PIN"
//           value={adminPin}
//           onChange={(e) => setAdminPin(e.target.value)}
//           style={{ marginRight: '0.5rem', padding: '0.4rem' }}
//         />
//         <button
//           onClick={handleAdminAccess}
//           style={{
//             backgroundColor: '#d9534f',
//             color: 'white',
//             padding: '0.6rem 1.2rem',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             fontSize: '1rem'
//           }}
//         >
//           🚀 Access Admin Dashboard
//         </button>
//       </div>

//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {notification && <div style={{ color: 'green' }}>{notification}</div>}

//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}

//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail
//           post={selectedPost}
//           onLike={handleLikePost}
//           onDislike={handleDislikePost}
//           onBack={handleBackToList}
//         />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;







// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// // ... (imports and setup remain unchanged)

// function ForumPage() {
//   // States...
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [notification, setNotification] = useState('');

//   // 🔐 Admin PIN access
//   const [adminPin, setAdminPin] = useState('');
//   const [adminAccessGranted, setAdminAccessGranted] = useState(false);

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true,
//         });
//         console.log('[ForumPage] Session check response =>', response.data);
//         if (response.data.isAuthenticated && response.data.user) {
//           setIsAuthenticated(true);
//           setHasSubscribed(!!response.data.user.hasSubscribed);
//           setUser(response.data.user);
//           if (response.data.user.sessionId) {
//             setSessionId(response.data.user.sessionId);
//             console.log('[ForumPage] sessionId =>', response.data.user.sessionId);
//           }
//         } else {
//           setIsAuthenticated(false);
//           setHasSubscribed(false);
//           setSessionId('');
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (error) {
//         console.error('[ForumPage] Error checking session:', error);
//         setIsAuthenticated(false);
//         setHasSubscribed(false);
//         setSessionId('');
//         setErrorMessage('Failed to check user session. Please try again.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkSession();
//   }, []);

//   useEffect(() => {
//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, {
//         withCredentials: true,
//       });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching posts:', err);
//       setErrorMessage('Could not load forum posts. Please try again later.');
//     }
//   };

//   const handleCreatePost = async (formData) => {
//     try {
//       formData.append('subscriberId', user.id);
//       const res = await axios.post(`${process.env.REACT_APP_API}/new/forum/post`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//         withCredentials: true,
//       });

//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//       setNotification('Post created successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error creating post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to create post.');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, {
//         withCredentials: true,
//       });
//       setSelectedPost(res.data.post);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching post:', err);
//       setErrorMessage('Could not load the selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/like/forum/post/${postId}`,
//         { subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p =>
//           p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p
//         )
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//       setNotification('Liked successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error liking post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleDislikePost = async (postId) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/dislike/forum/post/${postId}`,
//         { subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p =>
//           p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p
//         )
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//       setNotification('Disliked successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error disliking post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   const handleAdminAccess = () => {
//     if (adminPin === '1212') {
//       setAdminAccessGranted(true);
//       window.location.href = '/admin-dashboard';
//     } else {
//       alert('Invalid PIN. Access denied.');
//     }
//   };

//   if (!authChecked) return <p>Verifying session...</p>;
//   if (!isAuthenticated) return <p>Please log in to access the discussion forum.</p>;
//   if (!hasSubscribed) return <p>You must subscribe to access the discussion forum.</p>;

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>

//       {/* Admin PIN - now visible to ANY authenticated user */}
//       <div style={{ marginBottom: '1rem' }}>
//         <input
//           type="password"
//           placeholder="Enter Admin PIN"
//           value={adminPin}
//           onChange={(e) => setAdminPin(e.target.value)}
//           style={{ marginRight: '0.5rem', padding: '0.4rem' }}
//         />
//         <button
//           onClick={handleAdminAccess}
//           style={{
//             backgroundColor: '#d9534f',
//             color: 'white',
//             padding: '0.6rem 1.2rem',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             fontSize: '1rem'
//           }}
//         >
//           🚀 Access Admin Dashboard
//         </button>
//       </div>

//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {notification && <div style={{ color: 'green' }}>{notification}</div>}

//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}

//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}

//       {selectedPost ? (
//         <PostDetail
//           post={selectedPost}
//           onLike={handleLikePost}
//           onDislike={handleDislikePost}
//           onBack={handleBackToList}
//         />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;







// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// function ForumPage() {
//   // States for authentication and user info
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   // States for forum posts and UI feedback
//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [notification, setNotification] = useState('');

//   // Check session on mount
//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true,
//         });
//         console.log('[ForumPage] Session check response =>', response.data);
//         if (response.data.isAuthenticated && response.data.user) {
//           setIsAuthenticated(true);
//           setHasSubscribed(!!response.data.user.hasSubscribed);
//           setUser(response.data.user);
//           if (response.data.user.sessionId) {
//             setSessionId(response.data.user.sessionId);
//             console.log('[ForumPage] sessionId =>', response.data.user.sessionId);
//           }
//         } else {
//           setIsAuthenticated(false);
//           setHasSubscribed(false);
//           setSessionId('');
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (error) {
//         console.error('[ForumPage] Error checking session:', error);
//         setIsAuthenticated(false);
//         setHasSubscribed(false);
//         setSessionId('');
//         setErrorMessage('Failed to check user session. Please try again.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkSession();
//   }, []);

//   // Fetch posts once authentication is verified
//   useEffect(() => {
//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, {
//         withCredentials: true,
//       });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching posts:', err);
//       setErrorMessage('Could not load forum posts. Please try again later.');
//     }
//   };

//   const handleCreatePost = async (formData) => {
//     try {
//       formData.append('subscriberId', user.id); // append subscriberId inside FormData
  
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/new/forum/post`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//           withCredentials: true,
//         }
//       );
  
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//       setNotification('Post created successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error creating post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to create post.');
//     }
//   };
  

 

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, {
//         withCredentials: true,
//       });
//       setSelectedPost(res.data.post);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching post:', err);
//       setErrorMessage('Could not load the selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       // Send subscriberId with the like request
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/like/forum/post/${postId}`,
//         { subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p =>
//           p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p
//         )
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//       setNotification('Liked successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error liking post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleDislikePost = async (postId) => {
//     try {
//       // Send subscriberId with the dislike request; assumes a corresponding backend endpoint exists.
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/dislike/forum/post/${postId}`,
//         { subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p =>
//           p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p
//         )
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//       setNotification('Disliked successfully!');
//       setTimeout(() => setNotification(''), 3000);
//     } catch (err) {
//       console.error('[ForumPage] Error disliking post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to dislike post.');
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) {
//     return <p>Verifying session...</p>;
//   }
//   if (!isAuthenticated) {
//     return <p>Please log in to access the discussion forum.</p>;
//   }
//   if (!hasSubscribed) {
//     return <p>You must subscribe to access the discussion forum.</p>;
//   }

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>
//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {notification && <div style={{ color: 'green' }}>{notification}</div>}
//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}
//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail
//           post={selectedPost}
//           onLike={handleLikePost}
//           onDislike={handleDislikePost}
//           onBack={handleBackToList}
//         />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;



 // const handleCreatePost = async ({ title, content }) => {
  //   try {
  //     // Send subscriberId along with post details
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_API}/new/forum/post`,
  //       { title, content, subscriberId: user.id },
  //       { withCredentials: true }
  //     );
  //     setPosts([res.data.post, ...posts]);
  //     setShowNewPostForm(false);
  //     setNotification('Post created successfully!');
  //     setTimeout(() => setNotification(''), 3000);
  //   } catch (err) {
  //     console.error('[ForumPage] Error creating post:', err);
  //     setErrorMessage(
  //       err.response?.data?.message || 'Failed to create post. Are you subscribed?'
  //     );
  //   }
  // };







// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// function ForumPage() {
//   // States for authentication and user info
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [user, setUser] = useState(null);
//   const [authChecked, setAuthChecked] = useState(false);

//   // States for forum posts
//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   // Check session on mount
//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true,
//         });
//         console.log('[ForumPage] Session check response =>', response.data);
//         if (response.data.isAuthenticated && response.data.user) {
//           setIsAuthenticated(true);
//           setHasSubscribed(!!response.data.user.hasSubscribed);
//           setUser(response.data.user);
//           if (response.data.user.sessionId) {
//             setSessionId(response.data.user.sessionId);
//             console.log('[ForumPage] sessionId =>', response.data.user.sessionId);
//           }
//         } else {
//           setIsAuthenticated(false);
//           setHasSubscribed(false);
//           setSessionId('');
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (error) {
//         console.error('[ForumPage] Error checking session:', error);
//         setIsAuthenticated(false);
//         setHasSubscribed(false);
//         setSessionId('');
//         setErrorMessage('Failed to check user session. Please try again.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkSession();
//   }, []);

//   // Fetch posts once authentication is verified
//   useEffect(() => {
//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, {
//         withCredentials: true,
//       });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching posts:', err);
//       setErrorMessage('Could not load forum posts. Please try again later.');
//     }
//   };

//   const handleCreatePost = async ({ title, content }) => {
//     try {
//       // Send subscriberId along with post details
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/new/forum/post`,
//         { title, content, subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//     } catch (err) {
//       console.error('[ForumPage] Error creating post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to create post. Are you subscribed?');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, {
//         withCredentials: true,
//       });
//       setSelectedPost(res.data.post);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching post:', err);
//       setErrorMessage('Could not load the selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       // Send subscriberId with the like request
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/like/forum/post/${postId}`,
//         { subscriberId: user.id },
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p => (p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p))
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//     } catch (err) {
//       console.error('[ForumPage] Error liking post:', err);
//       setErrorMessage(err.response?.data?.message || 'Failed to like post.');
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) {
//     return <p>Verifying session...</p>;
//   }
//   if (!isAuthenticated) {
//     return <p>Please log in to access the discussion forum.</p>;
//   }
//   if (!hasSubscribed) {
//     return <p>You must subscribe to access the discussion forum.</p>;
//   }

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>
//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}
//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail post={selectedPost} onLike={handleLikePost} onBack={handleBackToList} />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;











// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// function ForumPage() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [authChecked, setAuthChecked] = useState(false);
  
//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true
//         });
//         console.log('[ForumPage] Session check response =>', response.data);
//         if (response.data.isAuthenticated && response.data.user) {
//           setIsAuthenticated(true);
//           setHasSubscribed(!!response.data.user.hasSubscribed);
//           if (response.data.user.sessionId) {
//             setSessionId(response.data.user.sessionId);
//             console.log('[ForumPage] sessionId =>', response.data.user.sessionId);
//           }
//         } else {
//           setIsAuthenticated(false);
//           setHasSubscribed(false);
//           setSessionId('');
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (error) {
//         console.error('[ForumPage] Error checking session:', error);
//         setIsAuthenticated(false);
//         setHasSubscribed(false);
//         setSessionId('');
//         setErrorMessage('Failed to check user session. Please try again.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkSession();
//   }, []);

//   useEffect(() => {
//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/all/forum/post`, {
//         withCredentials: true
//       });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching posts:', err);
//       setErrorMessage('Could not load forum posts. Please try again later.');
//     }
//   };

//   const handleCreatePost = async ({ title, content }) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/new/forum/post`,
//         { title, content },
//         { withCredentials: true }
//       );
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//     } catch (err) {
//       console.error('[ForumPage] Error creating post:', err);
//       setErrorMessage('Failed to create post. Are you subscribed?');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/get/a/forum/post/${postId}`, {
//         withCredentials: true
//       });
//       setSelectedPost(res.data.post);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching post:', err);
//       setErrorMessage('Could not load the selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/like/forum/post/${postId}`,
//         {},
//         { withCredentials: true }
//       );
//       setPosts(prevPosts =>
//         prevPosts.map(p => (p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p))
//       );
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//     } catch (err) {
//       console.error('[ForumPage] Error liking post:', err);
//       setErrorMessage('You must be subscribed to like posts.');
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) {
//     return <p>Verifying session...</p>;
//   }

//   if (!isAuthenticated) {
//     return <p>Please log in to access the discussion forum.</p>;
//   }

//   if (!hasSubscribed) {
//     return <p>You must subscribe to access the discussion forum.</p>;
//   }

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>
//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}
//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}
//       {selectedPost ? (
//         <PostDetail post={selectedPost} onLike={handleLikePost} onBack={handleBackToList} />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;





// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import PostList from './PostList';
// import PostDetail from './PostDetail';
// import NewPostForm from './NewPostForm';

// function ForumPage() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [hasSubscribed, setHasSubscribed] = useState(false);
//   const [sessionId, setSessionId] = useState('');
//   const [authChecked, setAuthChecked] = useState(false);

//   const [posts, setPosts] = useState([]);
//   const [selectedPost, setSelectedPost] = useState(null);
//   const [showNewPostForm, setShowNewPostForm] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');

//   useEffect(() => {
//     const checkSession = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true
//         });

//         console.log('[ForumPage] Session check response =>', response.data);

//         if (response.data.isAuthenticated && response.data.user) {
//           console.log('[ForumPage] user object =>', response.data.user);
//           console.log('[ForumPage] user.hasSubscribed =>', response.data.user.hasSubscribed);

//           setIsAuthenticated(true);
//           setHasSubscribed(!!response.data.user.hasSubscribed);

//           if (response.data.user.sessionId) {
//             setSessionId(response.data.user.sessionId);
//             console.log('[ForumPage] sessionId =>', response.data.user.sessionId);
//           }
//         } else {
//           console.warn('[ForumPage] Not authenticated or missing user object.');
//           setIsAuthenticated(false);
//           setHasSubscribed(false);
//           setSessionId('');
//           setErrorMessage('Please log in (and subscribe) to access the forum.');
//         }
//       } catch (error) {
//         console.error('[ForumPage] Error checking session:', error);
//         setIsAuthenticated(false);
//         setHasSubscribed(false);
//         setSessionId('');
//         setErrorMessage('Failed to check user session. Please try again.');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkSession();
//   }, []);

//   useEffect(() => {
//     console.log(
//       '[ForumPage] Effect run:',
//       `authChecked = ${authChecked}`,
//       `isAuthenticated = ${isAuthenticated}`,
//       `hasSubscribed = ${hasSubscribed}`
//     );

//     if (authChecked && isAuthenticated && hasSubscribed) {
//       fetchPosts();
//     }
//   }, [authChecked, isAuthenticated, hasSubscribed]);

//   const fetchPosts = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/api/forum/posts`, {
//         withCredentials: true
//       });
//       setPosts(res.data.posts || []);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching posts:', err);
//       setErrorMessage('Could not load forum posts. Please try again later.');
//     }
//   };

//   const handleCreatePost = async ({ title, content }) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/api/forum/posts`,
//         { title, content },
//         { withCredentials: true }
//       );
//       setPosts([res.data.post, ...posts]);
//       setShowNewPostForm(false);
//     } catch (err) {
//       console.error('[ForumPage] Error creating post:', err);
//       setErrorMessage('Failed to create post. Are you subscribed?');
//     }
//   };

//   const handleSelectPost = async (postId) => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_API}/api/forum/posts/${postId}`, {
//         withCredentials: true
//       });
//       setSelectedPost(res.data.post);
//     } catch (err) {
//       console.error('[ForumPage] Error fetching post:', err);
//       setErrorMessage('Could not load the selected post.');
//     }
//   };

//   const handleLikePost = async (postId) => {
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_API}/api/forum/posts/${postId}/like`,
//         {},
//         { withCredentials: true }
//       );
//       setPosts(prev => prev.map(
//         p => (p._id === postId ? { ...p, likes: res.data.updatedPost.likes } : p)
//       ));
//       if (selectedPost && selectedPost._id === postId) {
//         setSelectedPost({ ...selectedPost, likes: res.data.updatedPost.likes });
//       }
//     } catch (err) {
//       console.error('[ForumPage] Error liking post:', err);
//       setErrorMessage('You must be subscribed to like posts.');
//     }
//   };

//   const handleBackToList = () => {
//     setSelectedPost(null);
//     setShowNewPostForm(false);
//   };

//   if (!authChecked) {
//     return <p>Verifying session...</p>;
//   }

//   if (!isAuthenticated) {
//     return <p>Please log in to access the discussion forum.</p>;
//   }

//   if (!hasSubscribed) {
//     return <p>You must subscribe to access the discussion forum.</p>;
//   }

//   return (
//     <div style={{ padding: '1rem' }}>
//       <h2>Government Accounting Discussion Forum</h2>
//       {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}

//       {!selectedPost && !showNewPostForm && (
//         <button onClick={() => setShowNewPostForm(true)}>Create New Post</button>
//       )}
//       {showNewPostForm && <NewPostForm onCreate={handleCreatePost} />}

//       {selectedPost ? (
//         <PostDetail post={selectedPost} onLike={handleLikePost} onBack={handleBackToList} />
//       ) : (
//         <PostList posts={posts} onSelectPost={handleSelectPost} />
//       )}
//     </div>
//   );
// }

// export default ForumPage;
